import Vue from 'vue'
import moment from 'jalali-moment'
import app from '@/main'

function persian_digits(value) {
  if (localStorage.locale === 'en') return value

  const id = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']
  return String(value).replace(/[0-9]/g, function(w) {
    return id[+w]
  })
}

function thousands_separators(num) {
  const num_parts = num.toString().split('.')
  num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return num_parts.join('.')
}

Vue.filter('time', function(value) {
  if (value) {
    const res = moment(value)
      .locale(localStorage.locale)
      .format('HH:mm')

    return persian_digits(res)
  }
})

Vue.filter('date', function(value) {
  if (value) {
    const res = moment(value)
      .locale(localStorage.locale)
      .format('dddd, DD MMMM YYYY')

    return persian_digits(res)
  }
})

Vue.filter('datetime', function(value) {
  if (value) {
    const res = moment(value)
      .locale(localStorage.locale)
      .format('HH:mm dddd, DD MMMM YYYY')

    return persian_digits(res)
  }
})

Vue.filter('month', function(value, showYear = true) {
  if (value) {
    const format = showYear ? 'MMMM YYYY' : 'MMMM'
    const res = moment(value)
      .locale(localStorage.locale)
      .format(format)
    return persian_digits(res)
  }
})

Vue.filter('year', function(value) {
  if (value) {
    const res = moment(value)
      .locale(localStorage.locale)
      .format('YYYY')
    return persian_digits(res)
  }
})

Vue.filter('persian_digits', function(value) {
  return persian_digits(value)
})

Vue.filter('csv', function(value) {
  return value.join(', ')
})

Vue.filter('filter_tags', function(value) {
  return value.replace(/<\/?[^>]+(>|$)/g, '')
})

Vue.filter('thousands', function(value) {
  return persian_digits(thousands_separators(value))
})

Vue.filter('toman', function(value) {
  return persian_digits(thousands_separators(value)) + ' ' + app.$t('system.common.toman')
})

Vue.filter('age_range', function(value) {
  if (value < 10) {
    return app.$t('age_ranges.child')
  } else if (value < 20) {
    return app.$t('age_ranges.teenager')
  } else if (value < 40) {
    return app.$t('age_ranges.young')
  } else if (value < 60) {
    return app.$t('age_ranges.middle')
  } else {
    return app.$t('age_ranges.old')
  }
})
